import { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Form, Input, Label, FormGroup, Button } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import {
    getLegacyMarcas,
    getLegacyModelos,
    getLegacyColores,
    getLegacyTiposCombustible,
    getLegacyTiposTraccion,
    getLegacyTiposTransmision
} from '../../slices/thunks';
import useObtenerVehiculoPorPatente from '../Hooks/useObtenerVehiculoPorPatente';
import {
    buscarNombreMarca,
    buscarNombreModelo,
    buscarColor,
    buscarTipoCombustible,
    buscarTipoTraccion,
    buscarTipoTransmision
} from '../utils/vehicleLookups';

const ModalLeerVehiculo = ({ isOpen, toggle, selectedVehiculo }) => {
    const tenantId = useSelector((state) => state.Context.tenantId)
    const empresa = useSelector((state) => state.Context.empresa)
    const [vehiculoData, setVehiculoData] = useState({
        PATENT: '',
        CLIENT: '',
        MARCAS: '',
        MODELO: '',
        CCOLOR: '',
        ANOFAB: '',
        NROVIN: '',
        NCHASI: '',
        NMOTOR: '',
        TRASMI: '',
        TRACCI: '',
        COMBUS: ''
    });
    const [modeloPendiente, setModeloPendiente] = useState(null)

    const marcas = useSelector((state) => state.LegacyMarcas.legacyMarcas)
    const modelos = useSelector((state) => state.LegacyModelos.legacyModelos)
    const colores = useSelector((state) => state.LegacyColores.legacyColores)
    const tiposCombustible = useSelector((state) => state.LegacyTiposCombustible.legacyTiposCombustible)
    const tiposTraccion = useSelector((state) => state.LegacyTiposTraccion.legacyTiposTraccion)
    const tiposTransmision = useSelector((state) => state.LegacyTiposTransmision.legacyTiposTransmision)
    const dispatch = useDispatch()

    const { vehiculo, loading: loadingVehiculo } = useObtenerVehiculoPorPatente(isOpen ? selectedVehiculo : null);

    useEffect(() => {
        dispatch(getLegacyMarcas({ tenantId, empresa }))
        dispatch(getLegacyColores({ tenantId, empresa }))
        dispatch(getLegacyTiposCombustible({ tenantId, empresa }))
        dispatch(getLegacyTiposTraccion({ tenantId, empresa }))
        dispatch(getLegacyTiposTransmision({ tenantId, empresa }))
    }, [tenantId, empresa])

    useEffect(() => {
        if (vehiculo) {
            setVehiculoData({
                PATENT: vehiculo.PATENT || '',
                CLIENT: vehiculo.CLIENT || '',
                MARCAS: buscarNombreMarca(vehiculo.MARCAS, marcas) || vehiculo.MARCAS || '',
                MODELO: '',
                CCOLOR: buscarColor(vehiculo.CCOLOR, colores) || vehiculo.CCOLOR || '',
                ANOFAB: vehiculo.ANOFAB || '',
                NROVIN: vehiculo.NROVIN || '',
                NCHASI: vehiculo.NCHASI || '',
                NMOTOR: vehiculo.NMOTOR || '',
                TRASMI: buscarTipoTransmision(vehiculo.TRASMI, tiposTransmision) || vehiculo.TRASMI || '',
                TRACCI: buscarTipoTraccion(vehiculo.TRACCI, tiposTraccion) || vehiculo.TRACCI || '',
                COMBUS: buscarTipoCombustible(vehiculo.COMBUS, tiposCombustible) || vehiculo.COMBUS || ''
            });
            setModeloPendiente(vehiculo.MODELO);
            if (vehiculo.MARCAS) {
                dispatch(getLegacyModelos({ tenantId, empresa, marca: vehiculo.MARCAS }))
            }
        }
    }, [vehiculo])

    useEffect(() => {
        if (Array.isArray(modelos) && modelos?.length > 0) {
            if (modeloPendiente) {
                let modeloLabel = buscarNombreModelo(modeloPendiente, modelos) || modeloPendiente || '';
                setModeloPendiente(null)
                setVehiculoData(prev => ({ ...prev, MODELO: modeloLabel }));
            }
        }
    }, [modelos])

    const handleCancel = () => {
        setVehiculoData({
            PATENT: '',
            CLIENT: '',
            MARCAS: '',
            MODELO: '',
            CCOLOR: '',
            ANOFAB: '',
            NROVIN: '',
            NCHASI: '',
            NMOTOR: '',
            TRASMI: '',
            TRACCI: '',
            COMBUS: ''
        });
        setModeloPendiente(null);
        toggle();
    };

    return (
        <Modal isOpen={isOpen} toggle={handleCancel} size="lg">
            <ModalHeader toggle={handleCancel}>
                <i className="ri-eye-line me-2"></i>
                Ver Vehículo
            </ModalHeader>
            <ModalBody>
                <div>
                    {loadingVehiculo ? (
                        <div className="text-center">Cargando datos del vehículo...</div>
                    ) : (
                        <>
                            <div className="row">
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="PATENT">Patente</Label>
                                        <Input
                                            type="text"
                                            id="PATENT"
                                            name="PATENT"
                                            value={vehiculoData.PATENT}
                                            readOnly
                                        />
                                    </FormGroup>
                                </div>
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="CLIENT">Rut Propietario</Label>
                                        <Input
                                            type="text"
                                            id="CLIENT"
                                            name="CLIENT"
                                            value={vehiculoData.CLIENT}
                                            readOnly
                                        />
                                    </FormGroup>
                                </div>
                            </div>

                            <div className="d-flex align-items-center my-4">
                                <div className="flex-grow-1 border-top"></div>
                                <span className="mx-3 text-muted">Información del Vehículo</span>
                                <div className="flex-grow-1 border-top"></div>
                            </div>

                            <div className="row">
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="MARCAS">Marca</Label>
                                        <Input
                                            type="text"
                                            id="MARCAS"
                                            name="MARCAS"
                                            value={vehiculoData.MARCAS}
                                            readOnly
                                        />
                                    </FormGroup>
                                </div>
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="MODELO">Modelo</Label>
                                        <Input
                                            type="text"
                                            id="MODELO"
                                            name="MODELO"
                                            value={vehiculoData.MODELO}
                                            readOnly
                                        />
                                    </FormGroup>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="NROVIN">VIN</Label>
                                        <Input
                                            type="text"
                                            id="NROVIN"
                                            name="NROVIN"
                                            value={vehiculoData.NROVIN}
                                            readOnly
                                        />
                                    </FormGroup>
                                </div>
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="NCHASI">Chasis</Label>
                                        <Input
                                            type="text"
                                            id="NCHASI"
                                            name="NCHASI"
                                            value={vehiculoData.NCHASI}
                                            readOnly
                                        />
                                    </FormGroup>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="ANOFAB">Año</Label>
                                        <Input
                                            type="text"
                                            id="ANOFAB"
                                            name="ANOFAB"
                                            value={vehiculoData.ANOFAB}
                                            readOnly
                                        />
                                    </FormGroup>
                                </div>
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="NMOTOR">Motor</Label>
                                        <Input
                                            type="text"
                                            id="NMOTOR"
                                            name="NMOTOR"
                                            value={vehiculoData.NMOTOR}
                                            readOnly
                                        />
                                    </FormGroup>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="CCOLOR">Color</Label>
                                        <Input
                                            type="text"
                                            id="CCOLOR"
                                            name="CCOLOR"
                                            value={vehiculoData.CCOLOR}
                                            readOnly
                                        />
                                    </FormGroup>
                                </div>
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="TRASMI">Transmisión</Label>
                                        <Input
                                            type="text"
                                            id="TRASMI"
                                            name="TRASMI"
                                            value={vehiculoData.TRASMI}
                                            readOnly
                                        />
                                    </FormGroup>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="COMBUS">Combustible</Label>
                                        <Input
                                            type="text"
                                            id="COMBUS"
                                            name="COMBUS"
                                            value={vehiculoData.COMBUS}
                                            readOnly
                                        />
                                    </FormGroup>
                                </div>
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="TRACCI">Tracción</Label>
                                        <Input
                                            type="text"
                                            id="TRACCI"
                                            name="TRACCI"
                                            value={vehiculoData.TRACCI}
                                            readOnly
                                        />
                                    </FormGroup>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </ModalBody>
            <ModalFooter>
                <Button type="button" color="light" onClick={handleCancel}>
                    Cerrar
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default ModalLeerVehiculo;